/// <amd-module name="typeahead/core/StripingConfiguration"/>

// This interface is to enforce restrictions included
// as keys while running experiment or global rollout
export interface IStripingConfiguration {
    clients?: string[];
    siteids?: string[];
    tabs?: string[];
    lobs?: string[];
    locales?: string[];
    experiment?: UtaExperiment;
}

export function getExperiments(configurations: IStripingConfiguration[]): UtaExperiment[] {
    if (configurations && configurations.length) {
        return configurations.map((config) => {return config.experiment; })
                             .filter((experiment) => {return !!experiment; });
    }
    return [];
}
